'use client';

import Link from '@eliadmin/core/src/components/link';

import type { ContactPriceFormValues } from './contact-price-schema';
import type { UseFormReturn } from 'react-hook-form';

import { FormHeader } from './form-header';
import { FormContent } from './form-content';
import { Field } from '@eliadmin/core/src/components/form/field';
import { FormControl, FormField, FormItem, FormLabel } from '../../ui/form';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

interface SecondStepProps {
  title: string;
  step: number;
  form: UseFormReturn<ContactPriceFormValues>;
  locale: string;
}

export function SecondStep({ title, step, form, locale }: SecondStepProps) {
  const { t } = useTranslations();

  const GDPRlink =
    locale === 'sk' ? '/spracovanie-osobnych-udajov' : '/verarbeitung-personenbezogener-daten';

  return (
    <div className="flex w-full flex-col items-start justify-start gap-8">
      <FormHeader step={step} title={title} />
      <FormContent>
        <Field
          type="text"
          name="name"
          label={`${t('text3581')} *`}
          placeholder={t('text3582')}
          className={{ wrapper: 'w-full' }}
          control={form.control}
          required
        />
        <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
          <Field
            type="email"
            name="email"
            label="Email *"
            placeholder={t('text3583')}
            className={{ wrapper: 'w-full' }}
            control={form.control}
            required
          />
          <Field
            type="text"
            name="phone"
            label={`${t('text36')} *`}
            placeholder={t('text3584')}
            className={{ wrapper: 'w-full' }}
            control={form.control}
            required
          />
        </div>
        <Field
          type="text"
          name="text"
          label={t('text3585')}
          placeholder={t('text3586')}
          className={{ wrapper: 'w-full' }}
          control={form.control}
        />
        <FormField
          control={form.control}
          name="gdpr"
          render={({ field }) => (
            <FormItem
              className={cn(
                'flex w-full items-start gap-2',
                'ea-contact-form__gdpr-checkbox-item ea-contact-form__checkbox-item',
              )}
            >
              <FormControl>
                <Checkbox
                  ref={field.ref}
                  name={field.name}
                  disabled={field.disabled}
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  className={cn(
                    'h-6 w-6 rounded-none border border-black/10',
                    'ea-contact-form__gdpr-checkbox ea-contact-form__checkbox',
                  )}
                />
              </FormControl>
              <FormLabel className={cn('ea-contact-form__gdpr-checkbox-label')}>
                {t('text3587')}{' '}
                <Link prefetch={false} href={GDPRlink} className="underline" target="_blank">
                  {t('text614')}
                </Link>{' '}
                {t('text3389')}
              </FormLabel>
            </FormItem>
          )}
        />
      </FormContent>
    </div>
  );
}
